import React from 'react';

import { Dialog, DialogContent } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import Lottie from 'react-lottie';

import UploadingFileDark from 'assets/animations/uploading-file-dark.json';
import UploadingFileLight from 'assets/animations/uploading-file-light.json';
import { useAppSelector } from 'store';
import { mensagensSelector } from 'store/reducers/mensagens';

import DialogHeader from './DialogHeader';

export default function ModalAguardandoEnvioArquivo() {
  const { loadingEnviarArquivo } = useAppSelector(mensagensSelector);
  const theme = useTheme();

  return (
    <Dialog open={loadingEnviarArquivo} fullWidth maxWidth="sm">
      <DialogHeader title="Enviando arquivo" />
      <DialogContent>
        <Lottie
          isClickToPauseDisabled
          options={{
            animationData:
              theme.palette.type === 'dark'
                ? UploadingFileDark
                : UploadingFileLight,
          }}
          width={400}
        />
      </DialogContent>
    </Dialog>
  );
}
